export default {"src":"/_next/static/media/Header Logo.6bbcf6c3.svg","height":124,"width":180,"blurWidth":0,"blurHeight":0};